<template>
  <div class="idtr-block idtr-section">
    <div class="idtr-band">{{ text.fraudTitle }}</div>
    <table class="idtr-table idtr-fraud idtr-section__body">
      <colgroup>
        <col class="idtr-col--key" />
        <col class="idtr-col--val" />
      </colgroup>
      <tbody>
        <tr>
          <td class="idtr-cell--head">{{ text.accountsOrCharges }}</td>
          <td class="idtr-col--val">{{ text.accountsOrChargesValue }}</td>
        </tr>
        <tr v-if="idtrTemplate.hasInquiries">
          <td class="idtr-cell--head">
            <field-label target="idtr-inquiries" class="idtr-cell-fill">{{
              text.creditInquiries
            }}</field-label>
          </td>
          <td class="idtr-col--val idtr-cell--multiline">
            <field-editable id="idtr-inquiries" v-model="idtrForm.inquiries" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FieldEditable from "../FieldEditable.vue";
import FieldLabel from "../FieldLabel.vue";
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {FieldEditable, FieldLabel},
  inject: ["idtrForm", "idtrTemplate"],
  data: () => ({text: IDTR_TEXT}),
};
</script>
